import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircleIcon } from 'lucide-react';
interface ConsentFieldProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
  purpose: string;
}
export function ConsentField({
  id,
  checked,
  onChange,
  error,
  purpose
}: ConsentFieldProps) {
  return <div data-id="element-98" data-mp="gwscvwkxjd87">
      <div className="flex items-start gap-3" data-id="element-99" data-mp="gu62zqakglmt">
        <input id={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} aria-invalid={error ? true : undefined} aria-describedby={error ? `${id}-error` : undefined} className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded border-plum/30 accent-copper" data-id="element-100" data-mp="3pbamw3ufl2ug" />
        <label htmlFor={id} className="text-sm leading-relaxed text-plum/80" data-id="element-101" data-mp="3u9c3mi4dwq2r">
          I have read the{' '}
          <Link to="/privacy" className="font-medium text-copper-deep underline underline-offset-2" data-id="element-102" data-mp="31mhlvsyyc4sz">
            Privacy Policy
          </Link>{' '}
          and agree to Aurevane Search Partners using my information {purpose}.
          <span className="ml-0.5 text-copper-deep" aria-hidden="true" data-id="element-103" data-mp="2ap5pxi5a4eue">
            *
          </span>
        </label>
      </div>
      {error && <p id={`${id}-error`} className="ml-8 mt-2 flex items-start gap-1.5 text-sm text-danger" data-id="element-104" data-mp="2fis3rdn6iors">
          <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-105" data-mp="2jkdbylorqevn" />
          {error}
        </p>}
    </div>;
}